import React, { FunctionComponent, useMemo } from 'react'
import { getDistanceInWordsToNow } from '../../../../../misc/date.utilities'
import { HealthData } from '../../../../../model/HealthData'
import { stringifyHealthDataValueWithUnit } from '../../../../../misc/healthData.utilities'
import { TooltipWrapper } from '../../../../shared'
import styles from './PatientHealthDataItem.module.scss'

export const PatientHealthDataItem: FunctionComponent<HealthData> = (props) => {
  const { value, updatedAt, moduleDataType } = props

  const info = useMemo(() => {
    if (value.info) {
      return value.info
    }

    return `il y a ${getDistanceInWordsToNow(new Date(updatedAt))}`
  }, [value, updatedAt])

  return (
    <div className={styles.patientHealthDataItemContainer}>
      <div className={styles.patientHealthDataItemLabel}>{moduleDataType.name}</div>
      <TooltipWrapper content={info}>
        <div className={styles.patientHealthDataItemValue}>
          {stringifyHealthDataValueWithUnit(props)}
        </div>
      </TooltipWrapper>
    </div>
  )
}
